import { useTranslation } from 'react-i18next';
import { ActionModal } from '../../../mui/common/ActionModal.tsx';
import { Typography } from '@mui/material';

interface SaveFormModalProps {
  isSubmitting: boolean;
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  onClose: () => void;
}

export const SaveFormModal = ({ isSubmitting, open, onSubmit, onCancel, onClose }: SaveFormModalProps) => {
  const { t } = useTranslation();

  return (
    <ActionModal
      isSubmitting={isSubmitting}
      open={open}
      onSubmit={onSubmit}
      onClose={onCancel}
      onCancel={onClose}
      title={t('user.detail.modal.changeBehaviorTitle')}
      submitText={t('common.actions.saveAndProceed')}
      cancelText={t('common.actions.proceedWithoutChanges')}>
      <Typography variant="body1">{t('user.detail.modal.notifyUserToSave')}</Typography>
    </ActionModal>
  );
};
